/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityDomainsEmailAggData
 */
export interface ControlEntityDomainsEmailAggData {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDomainsEmailAggData
     */
    total?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityDomainsEmailAggData
     */
    domains?: Array<string>;
}

/**
 * Check if a given object implements the ControlEntityDomainsEmailAggData interface.
 */
export function instanceOfControlEntityDomainsEmailAggData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityDomainsEmailAggDataFromJSON(json: any): ControlEntityDomainsEmailAggData {
    return ControlEntityDomainsEmailAggDataFromJSONTyped(json, false);
}

export function ControlEntityDomainsEmailAggDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityDomainsEmailAggData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
    };
}

export function ControlEntityDomainsEmailAggDataToJSON(value?: ControlEntityDomainsEmailAggData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'domains': value.domains,
    };
}

